import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18d21a69"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  "data-view": ""
}
const _hoisted_2 = { class: "edit-profile" }
const _hoisted_3 = { class: "edit-profile__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "b-edit-profile__title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "edit-profile__title" }, "Edição de perfil"),
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_5 = { class: "edit-profile__options" }
const _hoisted_6 = { class: "edit-profile__form" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form__description" }, " Informações pessoais ", -1))
const _hoisted_9 = { class: "contain-inputs" }
const _hoisted_10 = { class: "contain-inputs__sub" }
const _hoisted_11 = { class: "contain-inputs__sub" }
const _hoisted_12 = { class: "contain-inputs__sub" }
const _hoisted_13 = { class: "contain-inputs__sub" }
const _hoisted_14 = { class: "contain-input" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Interesses", -1))
const _hoisted_16 = {
  key: 0,
  class: "contain-inputs__interest"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "contain-input" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adicionar novos interesses", -1))
const _hoisted_20 = {
  key: 0,
  class: "contain-inputs__interest"
}
const _hoisted_21 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CropperImageInput = _resolveComponent("CropperImageInput")!
  const _component_GrayInput = _resolveComponent("GrayInput")!
  const _component_MaskInput = _resolveComponent("MaskInput")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_CardSelect = _resolveComponent("CardSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isInputImageOpened)
      ? (_openBlock(), _createBlock(_component_CropperImageInput, {
          key: 0,
          "image-url": $setup.user.image,
          onCroppedImageUrl: _cache[0] || (_cache[0] = ($event: any) => ($setup.getCroppedImageUrl($event)))
        }, null, 8, ["image-url"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.saveChanges && $setup.saveChanges(...args))),
              class: "save-changes-button"
            }, " Salvar "),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.discardChanges && $setup.discardChanges(...args))),
              class: "discard-changes-button"
            }, " Cancelar ")
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "container-pic",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openInputImage()))
          }, [
            _createElementVNode("img", {
              id: "profile_pic",
              class: "container-pic__image",
              src: $setup.user.image,
              alt: $setup.user.name,
              onError: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.loadFallbackImage && $setup.loadFallbackImage(...args))),
              "data-profile-image": ""
            }, null, 40, _hoisted_7)
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["prevent"])),
            class: "form"
          }, [
            _hoisted_8,
            _createElementVNode("fieldset", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_GrayInput, {
                  id: "name",
                  modelValue: $setup.user.name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.user.name) = $event)),
                  type: "text",
                  placeholder: "Seu nome aqui",
                  hasCounter: "",
                  maxLength: "60",
                  disable: $setup.user.isImported && !$options.isCirculoTemplate(),
                  label: "Nome completo"
                }, null, 8, ["modelValue", "disable"]),
                _createVNode(_component_MaskInput, {
                  id: "cpf",
                  label: "CPF",
                  mask: "###.###.###-##",
                  placeholder: "000.000.000-00",
                  minLength: 14,
                  maxLength: 14,
                  modelValue: $setup.user.document,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.user.document) = $event)),
                  disabled: !!$setup.userDocument
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_GrayInput, {
                  id: "email",
                  type: "email",
                  placeholder: "exemplo@gmail.com",
                  modelValue: $setup.user.email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.user.email) = $event)),
                  hasCounter: "",
                  maxLength: "100",
                  disable: !!$setup.userEmail && !$options.isCirculoTemplate(),
                  label: "Email"
                }, null, 8, ["modelValue", "disable"]),
                _createVNode(_component_GrayInput, {
                  id: "birth-date",
                  type: "date",
                  modelValue: $setup.user.birthDate,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.user.birthDate) = $event)),
                  label: "Data de nascimento"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_MaskInput, {
                id: "zipCode",
                label: "CEP",
                mask: "#####-###",
                placeholder: "00000-000",
                minLength: 9,
                maxLength: 9,
                modelValue: $setup.user.address.zipCode,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.user.address.zipCode) = $event)),
                onInput: _cache[10] || (_cache[10] = ($event: any) => ($setup.requestCepAPI($setup.user.address.zipCode))),
                onBlur: _cache[11] || (_cache[11] = ($event: any) => ($setup.addEmptyValue($event.target)))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_GrayInput, {
                  id: "federalUnit",
                  readonly: $setup.user.address.zipCode?.length > 8,
                  type: "select",
                  options: [
                  { stateID: null, id: null, label: 'Selecionar' },
                  ...$setup.states
                ],
                  selectedID: $setup.user.address.stateID,
                  modelValue: $setup.user.address.stateID,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.user.address.stateID) = $event)),
                  label: "UF (Estado)"
                }, null, 8, ["readonly", "options", "selectedID", "modelValue"]),
                _createVNode(_component_GrayInput, {
                  id: "city",
                  class: "city",
                  readonly: $setup.user.address.zipCode?.length > 8,
                  type: "text",
                  placeholder: "Ex: Joinville, Curitiba, etc",
                  modelValue: $setup.user.address.city,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.user.address.city) = $event)),
                  label: "Cidade"
                }, null, 8, ["readonly", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_GrayInput, {
                  id: "district",
                  readonly: $setup.user.address.zipCode?.length > 8,
                  type: "text",
                  placeholder: "Ex: Sete de Setembro",
                  maxLength: "100",
                  hasCounter: "",
                  modelValue: $setup.user.address.district,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.user.address.district) = $event)),
                  label: "Bairro"
                }, null, 8, ["readonly", "modelValue"]),
                _createVNode(_component_NumberInput, {
                  id: "addressNumber",
                  type: "number",
                  placeholder: "0",
                  minLength: "0",
                  modelValue: $setup.user.address.addressNumber,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.user.address.addressNumber) = $event)),
                  label: "Número"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_GrayInput, {
                id: "street",
                readonly: $setup.user.address.zipCode?.length > 8,
                type: "text",
                placeholder: "Ex: Rua José da Cunha",
                modelValue: $setup.user.address.street,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.user.address.street) = $event)),
                label: "Rua"
              }, null, 8, ["readonly", "modelValue"]),
              _createVNode(_component_GrayInput, {
                id: "biography",
                type: "textarea",
                maxLength: "200",
                height: 120,
                resize: 'none',
                hasCounter: "",
                modelValue: $setup.user.biography,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.user.biography) = $event)),
                label: "Biografia"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                ($setup.user.interests?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.user.interests, (userInterest, userIndex) => {
                        return (_openBlock(), _createBlock(_component_CardSelect, {
                          key: userIndex,
                          label: userInterest.title,
                          "is-remove": "",
                          onClick: ($event: any) => ($setup.removeInterest(userInterest, userIndex))
                        }, null, 8, ["label", "onClick"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_17, " Você ainda não possui interesses."))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                ($setup.interests.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.interests, (interest, index) => {
                        return (_openBlock(), _createBlock(_component_CardSelect, {
                          key: index,
                          disable: $setup.user.interests?.length >= 5,
                          label: interest.title,
                          "is-select": "",
                          onClick: ($event: any) => ($setup.addInterest(interest, index))
                        }, null, 8, ["disable", "label", "onClick"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_21, "Não há mais interesses disponíveis para serem adicionados."))
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ], 64))
}